import React from "react";

export const DashboardCard = React.memo(function DashboardCard({ children, className = "" }) {
  return (
    <div className={`bg-white rounded-2xl border border-slate-200/70 shadow-sm p-5 flex flex-col ${className}`}>
      {children}
    </div>
  );
});